/* unplugin-vue-components disabled */import { render } from "./BaseImgUpload.vue?vue&type=template&id=07738651&scoped=true"
import script from "./BaseImgUpload.vue?vue&type=script&lang=js"
export * from "./BaseImgUpload.vue?vue&type=script&lang=js"

import "./BaseImgUpload.vue?vue&type=style&index=0&id=07738651&lang=stylus&scoped=true"

import exportComponent from "E:\\work\\AirLink-html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07738651"]])

export default __exports__